import {Link, Typography} from '@mui/material';
import RouterLink from '../../lib/RouterLink';
import {useArticles} from '../hooks/useArticles';
import {useHelpBasePath} from '../hooks/useHelpLocale';

type ArticleLinkProps = {
  slug: string;
  displayText?: string;
};

const ArticleLink = ({slug, displayText}: ArticleLinkProps) => {
  const {getArticleBySlug} = useArticles();
  const helpBasePath = useHelpBasePath();
  const article = getArticleBySlug(slug);

  if (!article) {
    return (
      <Typography component="span" color="error">
        {displayText || slug} (broken link)
      </Typography>
    );
  }

  return (
    <Link component={RouterLink} to={`${helpBasePath}/${slug}`}>
      {displayText || article.title}
    </Link>
  );
};

export default ArticleLink;
